module.exports = __webpack_public_path__ + "img/txt_series_114.b7286314.png";